import styled, { css } from 'styled-components';
import Typography from '../typography/Typography';
export const OptionListContainer = styled.div `
  padding: 0.5rem 2.2rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.high};
`;
export const TextWrapper = styled.div `
  width: -webkit-fill-available;
`;
export const DescriptionWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: ${({ spaceBetween }) => (spaceBetween ? 'start' : 'end')};
  text-align: ${({ spaceBetween }) => (spaceBetween ? 'left' : 'right')};

  width: -webkit-fill-available;

  word-break: break-word;
`;
export const ItemContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;

  ${({ optionHeight }) => optionHeight &&
    css `
      min-height: ${optionHeight}rem;
    `};

  padding: 1.5rem 0;

  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};

  &:last-child {
    border-bottom: none;
  }
`;
export const Description = styled(Typography) `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map